import React, {useState} from 'react';
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";

type DialogProps = {
    visible: boolean
    setVisible: (state: boolean) => void
    confirmMessage?: string

    confirmedCallback: () => void
}

const ConfirmDialog = ({visible, setVisible, confirmMessage = "confirm", confirmedCallback}: DialogProps) => {
    const [message, setMessage] = useState("")
    const footer = () => {
        return <div>
            <Button onClick={() => setVisible(false)}
                    label={"Cancel"}
                    icon={"pi pi-times"}
                    className={"p-button-danger"}
            />
            <Button onClick={() => {
                confirmedCallback()
                setVisible(false)
            }}
                    label={"Confirm"}
                    disabled={message !== confirmMessage}
                    icon={"pi pi-confirm"}
                    className={"p-button-success"}
            />
        </div>
    }

    return <Dialog onHide={() => setVisible(false)}
                   visible={visible}
                   header={"Confirm Action"}
                   footer={footer}
    >
        <div className={"flex flex-column gap-1"}>
            <div>If you want to confirm your action. Write - [ <b>{confirmMessage}</b> ]</div>
            <InputText onChange={event => setMessage(event.target.value)} value={message}/>
        </div>
    </Dialog>
};

export default ConfirmDialog;